module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAFCAYAAADL2YVPAAAASElEQVQokcXSoRWAMBAE0QmaHpJi6BqTGF76iUMwvBO0wP0GdsSiVrWrj/+L3VbUEzjI0yNiAXtixL0BMzEgXN8nRsIfwlDbC6ssDdPtD5XrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/minus.png
// module id = G0MN
// module chunks = 1